import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTextIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 32,
	viewBox: "0 0 40 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 32,
			rx: 4,
			fill: "#76ec71"
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_612_9003)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M20.9277 17.8936L16.1652 8.90293C16.1019 8.78104 16.0063 8.67887 15.889 8.60756C15.7716 8.53625 15.6369 8.49854 15.4995 8.49854C15.3622 8.49854 15.2275 8.53625 15.1101 8.60756C14.9927 8.67887 14.8972 8.78104 14.8339 8.90293L10.0714 17.8936L8.08392 21.6529C7.99427 21.8299 7.97743 22.0349 8.037 22.2241C8.09657 22.4133 8.22781 22.5717 8.40267 22.6654C8.57963 22.7551 8.78464 22.7719 8.97386 22.7123C9.16308 22.6528 9.32147 22.5215 9.41517 22.3467L11.187 18.9998H19.812L21.5839 22.3467C21.6465 22.469 21.742 22.5715 21.8595 22.6427C21.9771 22.7139 22.1121 22.751 22.2495 22.7498C22.3785 22.7499 22.5054 22.7168 22.6178 22.6535C22.7302 22.5903 22.8245 22.4992 22.8914 22.3889C22.9583 22.2786 22.9956 22.153 22.9998 22.024C23.004 21.8951 22.9748 21.7673 22.9152 21.6529L20.9277 17.8936ZM11.9839 17.4998L15.4995 10.8529L19.0152 17.4998H11.9839ZM27.4995 12.8967C26.4651 12.8866 25.4683 13.284 24.7245 14.0029C24.6487 14.0705 24.5875 14.1528 24.5444 14.2447C24.5013 14.3367 24.4774 14.4365 24.474 14.538C24.4707 14.6395 24.488 14.7406 24.5249 14.8352C24.5618 14.9298 24.6175 15.0159 24.6886 15.0884C24.7598 15.1608 24.8449 15.218 24.9389 15.2566C25.0328 15.2951 25.1336 15.3142 25.2352 15.3127C25.3367 15.3111 25.4369 15.2889 25.5296 15.2475C25.6223 15.2061 25.7056 15.1463 25.7745 15.0717C26.2383 14.6285 26.8581 14.3859 27.4995 14.3967C28.737 14.3967 29.7495 15.2404 29.7495 16.2717V16.9467C29.0832 16.5033 28.2999 16.2683 27.4995 16.2717C25.4277 16.2717 23.7495 17.7811 23.7495 19.6467C23.7495 21.5123 25.4277 23.0217 27.4995 23.0217C28.3273 23.0251 29.136 22.773 29.8152 22.2998C29.8723 22.4338 29.9678 22.548 30.0895 22.628C30.2112 22.7081 30.3539 22.7504 30.4995 22.7498C30.6985 22.7498 30.8892 22.6708 31.0299 22.5301C31.1705 22.3895 31.2495 22.1987 31.2495 21.9998V16.2717C31.2495 14.4061 29.5714 12.8967 27.4995 12.8967ZM27.4995 21.5217C26.262 21.5217 25.2495 20.6779 25.2495 19.6467C25.2495 18.6154 26.262 17.7717 27.4995 17.7717C28.737 17.7717 29.7495 18.6154 29.7495 19.6467C29.7495 20.6779 28.737 21.5217 27.4995 21.5217Z",
				fill: "#0f172b"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_612_9003",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white",
				transform: "translate(8 4)"
			})
		}) })
	]
});
export default SvgTextIcon;
